import React from 'react';

const RoundedCloseIcon = ({ size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 40 700 1024"
    {...props}
  >
    <path
      d="M511.9 183c-181.8 0-329.1 147.4-329.1 329.1s147.4 329.1 329.1 329.1S841 693.9 841 512.2 693.6 183 511.9 183z m0 585.2c-141.2 0-256-114.8-256-256s114.8-256 256-256 256 114.8 256 256-114.9 256-256 256z"
      fill="currentColor"
    />
    <path
      d="M595.8 376.5l-83.9 83.9-83.9-83.9-51.8 51.7 83.9 84-83.9 83.9 51.8 51.7 83.9-83.9 83.9 83.9 51.7-51.7-83.9-83.9 83.9-84z"
      fill="currentColor"
    />
  </svg>
);

export default RoundedCloseIcon;
